import React, { useRef, useState } from 'react';
import styles from './Table.module.css';
import { ReactSVG } from 'react-svg';
import { Icons } from '@/assets';
import { useOutsideAlerter } from '@/hocs';

const MoreMenu = ({ moreActions, row }) => {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  useOutsideAlerter(ref, () => setIsOpen(false));

  const handleClick = (row, cb) => {
    setIsOpen(false);
    cb(row);
  };

  return (
    <div className={styles.container}>
      <div
        ref={ref}
        onClick={() => setIsOpen(true)}
        className={styles.icondiv}
        // Ensure the icon container has a low z-index
        style={{ zIndex: 1 }}>
        <ReactSVG src={Icons.action} className={styles.icon} />
      </div>

      {isOpen && (
        <div
          className={styles.menu}
          style={{
            zIndex: 10000, // Ensure the menu appears above the icon
          }}>
          {moreActions?.map((item) => (
            <div
              key={item.label}
              className={styles.menuItem}
              onClick={() => handleClick(row, item.clickHandler)}>
              <ReactSVG src={Icons[item.icon]} className={styles.actionIcon} />
              {item.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MoreMenu;
